import React, { FC } from 'react'
import { GridColDef } from '@mui/x-data-grid-premium'
import { SensorColumnsDataGrid } from 'src/components/columns/sensor'
import { Sensor, SensorState } from 'src/api'
import { SensorListFilters } from 'src/components/forms/sensor'
import { SensorFilters, SensorButtons } from 'src/enums'
import { CommonSensorList } from '../commonSensorsList'
import { SensorContextMenu, SensorMenuItemKey, useSensorContextMenu, createActionsColumn } from '../sensorContextMenu'

interface AvailableLoRaWanSensorListProps {
  isLoading: boolean
  count: number
  data: Sensor[]
  states: SensorState[]
  refetchSensorList: () => void
}

export const AvailableLoRaWanSensorList: FC<AvailableLoRaWanSensorListProps> = ({ data, isLoading, count, states, refetchSensorList }) => {
  const { currentRow, menuAnchorEl, handleOpenMenu, handleCloseMenu } = useSensorContextMenu()

  const columns: GridColDef<Sensor>[] = [
    SensorColumnsDataGrid.Id(),
    SensorColumnsDataGrid.Model,
    SensorColumnsDataGrid.DevEUI,
    SensorColumnsDataGrid.LastPing,
    SensorColumnsDataGrid.BatteryLevel,
    SensorColumnsDataGrid.DateAdded,
    SensorColumnsDataGrid.Description,
    createActionsColumn(handleOpenMenu)
  ]

  return (
    <>
      <CommonSensorList
        columns={columns}
        count={count}
        data={data}
        isLoading={isLoading}
        filters={<SensorListFilters activeFilters={[SensorFilters.LowBattery, SensorFilters.WeakSignal, SensorFilters.LastPingMoreThanHour]} />}
        buttons={[SensorButtons.DownloadLabels]}
        checkboxSelection
      />
      <SensorContextMenu
        menuItems={[SensorMenuItemKey.Assign, SensorMenuItemKey.MarkAsLost]}
        currentRow={currentRow}
        menuAnchorEl={menuAnchorEl}
        onOpenMenu={handleOpenMenu}
        onCloseMenu={handleCloseMenu}
        states={states}
        refetchSensorList={refetchSensorList}
      />
    </>
  )
}
